export const maxContentWidth = '1400px';

// CMS Site Mobile header height, for offsets:
export const headerHeightXs = 64;

// CMS Site Desktop header height, for offsets:
export const headerHeightLg = 96;
